"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  v: '5.5.7',
  meta: {
    g: 'LottieFiles AE 0.1.21',
    a: '',
    k: '',
    d: '',
    tc: ''
  },
  fr: 24,
  ip: 0,
  op: 120,
  w: 350,
  h: 320,
  nm: 'Checkout Animation_350x320_V2',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: 'tick',
    parent: 2,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [29.5, 36.171, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [63.538, 63.538, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 22,
            s: [{
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-20.75, -7.375], [-20.75, -7.375], [-20.75, -7.375]],
              c: false
            }]
          }, {
            i: {
              x: 0.048,
              y: 1
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 26,
            s: [{
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-20.75, -7.375], [-5.5, 6.25], [-5.5, 6.25]],
              c: false
            }]
          }, {
            t: 31,
            s: [{
              i: [[0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0]],
              v: [[-20.75, -7.375], [-5.5, 6.25], [20.375, -23.25]],
              c: false
            }]
          }],
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 1, 0.980392156863, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 8,
          ix: 5
        },
        lc: 2,
        lj: 2,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 20,
    op: 224,
    st: -16,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: 'blue circle',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [174.607, 149.107, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [29.25, 29.25, 0],
        ix: 1
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.833, 0.833, 0.833],
            y: [0.833, 0.833, 0.833]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0.167, 0.167, 0.167]
          },
          t: 20,
          s: [0, 0, 100]
        }, {
          i: {
            x: [0.459, 0.459, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.581, 0.581, 0.333],
            y: [0, 0, 0]
          },
          t: 24,
          s: [177.387, 177.387, 100]
        }, {
          t: 29,
          s: [157.387, 157.387, 100]
        }],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-16.016, 0], [0, -16.016], [16.017, 0], [0, 16.016]],
            o: [[16.017, 0], [0, 16.016], [-16.016, 0], [0, -16.016]],
            v: [[0, -29], [29, 0], [0, 29], [-29, 0]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.513725490196, 0.392156862745, 0.749019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [29.25, 29.25],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 20,
    op: 224,
    st: -16,
    bm: 0
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: 'sparkles',
    parent: 14,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [70.25, 38.338, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [76.55, 30.262, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[6.2, 0], [-0.199, 5.6], [0, 0], [0, 0], [-5.6, -0.3], [0, 0], [0, 0], [0, -6.5]],
            o: [[2.5, -0.2], [0, 0], [0, 0], [0, 3.1], [0, 0], [0, 0], [-2.6, 0], [0, -3.2]],
            v: [[-7.65, -0.65], [0.15, -8.45], [0.15, -8.75], [0.15, -8.45], [7.15, 0.65], [7.65, 0.65], [7.15, 0.65], [0.15, 8.75]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 0,
            s: [145.2, 33.124],
            to: [0, 0],
            ti: [0, 0]
          }, {
            t: 119,
            s: [145.2, 33.124]
          }],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 0,
            s: [66, 66]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 19.199,
            s: [130, 130]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 40,
            s: [66, 66]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 59.199,
            s: [130, 130]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 80,
            s: [66, 66]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 99.199,
            s: [130, 130]
          }, {
            t: 120,
            s: [66, 66]
          }],
          ix: 3
        },
        r: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 0,
            s: [0]
          }, {
            t: 120,
            s: [360]
          }],
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-1.215, 0], [0, -1.215], [1.215, 0], [0, 1.215]],
            o: [[1.215, 0], [0, 1.215], [-1.215, 0], [0, -1.215]],
            v: [[0, -2.2], [2.2, 0], [0, 2.2], [-2.2, 0]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.788235294118, 0.701960784314, 1, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 3.674,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 0,
            s: [131.95, 5.874],
            to: [0, 0],
            ti: [0, 0]
          }, {
            t: 119,
            s: [131.95, 5.874]
          }],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 0,
            s: [66, 66]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 32,
            s: [95, 95]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 62,
            s: [66, 66]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 90,
            s: [95, 95]
          }, {
            t: 120,
            s: [66, 66]
          }],
          ix: 3
        },
        r: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 0,
            s: [0]
          }, {
            t: 120,
            s: [360]
          }],
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[5.5, -2.5], [2.3, 5.2], [0, 0], [0, 0], [-5.2, 2], [-0.1, 0.1], [0.1, -0.1], [-2.7, -5.9]],
            o: [[2.2, -1.3], [0, -0.1], [0, 0.1], [1.3, 2.8], [0.1, -0.1], [-0.1, 0.1], [-2.3, 1.1], [-1.3, -2.9]],
            v: [[-7.05, 2.55], [-3.45, -7.75], [-3.55, -7.95], [-3.45, -7.75], [6.65, -2.35], [7.05, -2.55], [6.65, -2.35], [3.75, 7.95]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 0,
            s: [7.3, 52.324],
            to: [0, 0],
            ti: [0, 0]
          }, {
            t: 119,
            s: [7.3, 52.324]
          }],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 1,
          k: [{
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 0,
            s: [130, 130]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 20.801,
            s: [66, 66]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 40,
            s: [130, 130]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 60.801,
            s: [66, 66]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 80,
            s: [130, 130]
          }, {
            i: {
              x: [0.667, 0.667],
              y: [1, 1]
            },
            o: {
              x: [0.333, 0.333],
              y: [0, 0]
            },
            t: 100.801,
            s: [66, 66]
          }, {
            t: 120,
            s: [130, 130]
          }],
          ix: 3
        },
        r: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 0,
            s: [0]
          }, {
            t: 120,
            s: [360]
          }],
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 3,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: 'arm',
    parent: 9,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [23.2, 23.7, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [23.1, 21, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-4.8, -3.5], [-0.8, -1.3], [-5.1, -0.7], [1.3, -1.8], [4.4, -0.1], [2.8, 17]],
            o: [[5.6, 4.1], [2.6, 5.1], [0.3, 0.9], [-2, 0.9], [-6.1, 0.1], [-3.3, -19.5]],
            v: [[-4.4, -17.25], [-1.7, 3.05], [17.8, 12.05], [15.4, 17.05], [8.4, 18.45], [-14.8, 3.75]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [18.35, 21],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-3.9, -0.5], [-0.3, -0.1], [-0.2, -2.7], [1, -0.3], [1.6, -0.8], [1.4, 0.9]],
            o: [[0.3, 0], [0.7, 0.1], [0.1, 1], [-6.6, 2.3], [0, 0], [-5.2, -3.2]],
            v: [[0, -3.4], [6, -4.1], [9.1, -0.3], [7.6, 1.9], [1.4, -0.2], [-4, 0.2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [36.75, 36.55],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: 'cart',
    parent: 14,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.324,
            y: 1
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 0,
          s: [89.661, 98.65, 0],
          to: [1.532, 0, 0],
          ti: [-1.532, 0, 0]
        }, {
          t: 11,
          s: [98.85, 98.65, 0]
        }],
        ix: 2
      },
      a: {
        a: 0,
        k: [43.65, 47.15, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-0.3, 0], [0, 0], [0.1, 0.4], [2.1, 1.4], [0.1, 0], [0.1, -0.5], [-0.5, -0.1], [-2, -1.5], [-1.8, -4.9]],
            o: [[0, 0], [0.4, -0.1], [-1.9, -5.4], [-2.3, -1.6], [-0.4, -0.1], [-0.1, 0.4], [0, 0], [1.9, 1.3], [0.1, 0.2]],
            v: [[5.4, 6.35], [5.6, 6.35], [6.1, 5.35], [-0.9, -4.35], [-5.2, -6.25], [-6.1, -5.55], [-5.4, -4.65], [-1.7, -2.95], [4.7, 5.95]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.513725490196, 0.392156862745, 0.749019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [8.729, 14.16],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 15',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-1.4, 0], [-0.5, 0.1], [0, 0.1], [0.3, 0.1], [0.1, -0.3], [3.9, -1], [0, 0], [0.2, -0.1], [-0.1, -0.2], [-1.2, -0.9]],
            o: [[0.5, 0], [4.5, -1.2], [0.1, -0.3], [-0.3, -0.1], [0, 0.1], [-3.8, 1], [-0.1, -0.2], [-0.2, 0.1], [0, 0], [1.2, 1]],
            v: [[-0.5, 2.9], [1, 2.7], [6.3, -2.2], [5.9, -2.8], [5.3, -2.4], [0.7, 1.8], [-5.4, -1.1], [-6.1, -1.3], [-6.3, -0.6], [-4.4, 1.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.929411764706, 0.901960784314, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [42.75, 15.05],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-0.1, 0], [0, 0], [0.1, 0.2], [-0.8, 1.5], [-0.6, 0.1], [0, -0.1], [-0.3, 0.1], [0.1, 0.3], [4.4, -0.5], [0.3, -0.7], [-0.1, -0.1]],
            o: [[0, 0], [0.2, -0.1], [-0.6, -1.2], [0.2, -0.5], [3.7, -0.4], [0.1, 0.2], [0.2, -0.1], [-0.1, -0.3], [-1, 0.1], [-1.2, 2.2], [0, 0.2]],
            v: [[-2.35, 4.4], [-2.15, 4.4], [-1.95, 3.8], [-3.15, -2.2], [-1.85, -3], [4.05, 3.6], [4.65, 3.9], [4.95, 3.3], [-1.85, -3.9], [-3.85, -2.7], [-2.65, 4.1]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.929411764706, 0.901960784314, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [38.6, 28.35],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 3,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0.8, 2.8], [1.201, -1.1], [0, 0], [1, -0.6], [0, 0], [0.799, -0.6], [0, 0], [2.399, -0.9], [-2.301, -1.5]],
            o: [[0, 0], [-0.7, -2.8], [-1.2, 1.1], [0, 0], [-1, 0.6], [0, 0], [-0.801, 0.6], [0, 0], [-2.401, 1], [0, 0]],
            v: [[5.5, 3.5], [8.5, -0.9], [4.9, -2], [3, 0.3], [1, -0.7], [-0.3, 0.9], [-1.399, -0.4], [-2.8, 1.2], [-6.899, -2.2], [-4.899, 3.7]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.85882358925, 0.800000059838, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [68.55, 13.15],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 4,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[17.3, 2.2], [-17.301, 2.6], [-17.9, -1.9], [17.9, -2.6]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.788235294118, 0.701960784314, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [69.151, 18.95],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 4',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 5,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [2.6, -1], [0, 0]],
            o: [[0, 0], [-2.6, 1], [0, 0]],
            v: [[0.8, -3.6], [0.8, 3.5], [-3.4, -4.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.513725490196, 0.392156862745, 0.749019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [80.95, 85.35],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 5',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 6,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[2.9, 0], [0, 2.901], [-2.9, 0], [0, -2.9]],
            o: [[-2.9, 0], [0, -2.9], [2.9, 0], [0, 2.901]],
            v: [[0, 5.3], [-5.3, 0], [0, -5.3], [5.3, 0]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.23137254902, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [81.75, 88.75],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 6',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 7,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-1.3, 1.9], [0, 0.5], [0, 0], [1, -1.4], [-0.401, -1.1], [-0.901, -0.3], [-6.4, -0.801], [0, -0.5], [0.5, 0.099], [6.7, 2], [0, -0.8], [0, 0], [0.5, 0], [0, 0.5], [0, 0], [0.101, 0.5]],
            o: [[0.601, -0.9], [0, 0], [0, 1.1], [-1, 1.4], [0.3, 0.8], [6.5, 1.9], [0.5, 0.099], [-0.101, 0.5], [-6.599, -0.801], [-0.701, -0.2], [0, 0], [0, 0.6], [-0.599, 0], [0, 0], [0, -0.4], [-0.8, -2.1]],
            v: [[-24.501, -10.1], [-23.101, -12.7], [-21.101, -12.7], [-22.9, -9], [-24.7, -4.7], [-22.4, -3.2], [26.4, 4.001], [27.301, 5.1], [26.2, 6.001], [-22.9, -1.2], [-24.301, -0.1], [-24.301, 11.7], [-25.301, 12.7], [-26.301, 11.7], [-26.301, -2.6], [-26.501, -3.9]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.513725490196, 0.392156862745, 0.749019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [58.35, 76.65],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 7',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 8,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[-29.8, -4.5], [-18.6, -4.5], [-18.6, -20], [-35.2, -21.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 1,
        ty: 'sh',
        ix: 2,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[-25.2, 9.9], [-18.7, 9.9], [-18.7, -3.3], [-29.5, -3.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 2',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 2,
        ty: 'sh',
        ix: 3,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[-21.4, 21.5], [-18.6, 21.5], [-18.6, 11.2], [-24.7, 11.2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 3,
        ty: 'sh',
        ix: 4,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[35.7, 11.2], [24.7, 11.2], [24.7, 21.5], [35.7, 21.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 4',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 4,
        ty: 'sh',
        ix: 5,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[24.7, -16.1], [24.7, -4.5], [35.7, -4.5], [35.7, -15.2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 5',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 5,
        ty: 'sh',
        ix: 6,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[-4.6, -4.5], [-4.6, -18.8], [-17.3, -19.9], [-17.3, -4.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 6',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 6,
        ty: 'sh',
        ix: 7,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[-4.6, -3.3], [-17.3, -3.3], [-17.3, 9.9], [-4.6, 9.9]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 7',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 7,
        ty: 'sh',
        ix: 8,
        ks: {
          a: 0,
          k: {
            i: [[0, 0]],
            o: [[0, 0]],
            v: [[-4.6, 9.9]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 8',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 8,
        ty: 'sh',
        ix: 9,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[-4.6, 11.2], [-17.3, 11.2], [-17.3, 21.5], [-4.6, 21.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 9',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 9,
        ty: 'sh',
        ix: 10,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[9.4, 11.2], [-3.3, 11.2], [-3.3, 21.5], [9.4, 21.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 10',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 10,
        ty: 'sh',
        ix: 11,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[10.7, 21.5], [23.4, 21.5], [23.4, 11.2], [10.7, 11.2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 11',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 11,
        ty: 'sh',
        ix: 12,
        ks: {
          a: 0,
          k: {
            i: [[0, 0]],
            o: [[0, 0]],
            v: [[10.7, 11.2]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 12',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 12,
        ty: 'sh',
        ix: 13,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[10.7, -4.5], [23.4, -4.5], [23.4, -16.3], [10.7, -17.4]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 13',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 13,
        ty: 'sh',
        ix: 14,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[-3.3, 9.9], [9.4, 9.9], [9.4, -3.3], [-3.3, -3.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 14',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 14,
        ty: 'sh',
        ix: 15,
        ks: {
          a: 0,
          k: {
            i: [[0, 0]],
            o: [[0, 0]],
            v: [[-3.3, -3.3]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 15',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 15,
        ty: 'sh',
        ix: 16,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[9.4, -4.5], [9.4, -17.5], [-3.3, -18.6], [-3.3, -4.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 16',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 16,
        ty: 'sh',
        ix: 17,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[24.7, 9.9], [35.7, 9.9], [35.7, -3.3], [24.7, -3.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 17',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 17,
        ty: 'sh',
        ix: 18,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[23.4, -3.3], [10.7, -3.3], [10.7, 9.9], [23.4, 9.9]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 18',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 18,
        ty: 'sh',
        ix: 19,
        ks: {
          a: 0,
          k: {
            i: [[-0.1, 0.2], [-0.2, 0], [0, 0], [0, -0.3], [0, 0], [0.3, 0], [0, 0], [0.1, 0.2], [0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0.1, -0.2], [0, 0], [0.3, 0], [0, 0], [0, 0.4], [0, 0], [-0.3, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-0.1, -0.3]],
            v: [[-36.7, -22.6], [-36.1, -22.8], [36.3, -16.3], [36.9, -15.7], [36.9, 22.2], [36.3, 22.8], [-21.9, 22.8], [-22.5, 22.4], [-30.8, -3.2], [-30.9, -3.2], [-30.9, -3.5], [-36.8, -21.9]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 19',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'mm',
        mm: 1,
        nm: 'Merge Paths 1',
        mn: 'ADBE Vector Filter - Merge',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.513725490196, 0.392156862745, 0.749019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [50.05, 41.55],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 8',
      np: 23,
      cix: 2,
      bm: 0,
      ix: 9,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[1, -0.2], [0, 0], [-0.201, -0.8], [0, 0], [-0.9, 0.2], [0, 0], [0.101, 0.8]],
            o: [[0, 0], [-0.9, 0.2], [0, 0], [0.3, 0.8], [0, 0], [0.901, -0.2], [-0.199, -1]],
            v: [[15, -4.75], [-15.601, 1.45], [-16.9, 3.35], [-16.801, 3.65], [-14.801, 4.75], [15.7, -1.65], [17, -3.35]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.513725490196, 0.392156862745, 0.749019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [17.35, 5.2],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 9',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 10,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[2.9, 0], [0, 2.901], [-2.9, 0], [0, -2.9]],
            o: [[-2.9, 0], [0, -2.9], [2.9, 0], [0, 2.901]],
            v: [[0, 5.3], [-5.3, 0], [0, -5.3], [5.3, 0]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.23137254902, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [33.75, 88.75],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 10',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 11,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[15.8, -21.75], [8.2, 21.75], [-8.8, 21.75], [-15.8, -21.75]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.858823529412, 0.8, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [69.55, 41.8],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 11',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 12,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[9.85, -17.3], [-14.45, -16.1], [-13.05, 16.9], [14.45, 17.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.858823529412, 0.8, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [41.4, 46.65],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 12',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 13,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
            v: [[14.95, -16.05], [13.749, -27.25], [-19.051, -22.05], [-9.051, 25.85], [19.051, 27.25]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.788235353956, 0.701960784314, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [45.101, 35.9],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 13',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 14,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-0.4, 0], [0, 0.4], [1.7, 2.5], [0.1, 0], [0.3, -0.3], [-0.3, -0.3], [-1.7, -2.6], [0, -5.3]],
            o: [[0.4, 0], [-0.1, -5.8], [-1.8, -2.8], [-0.4, -0.2], [-0.2, 0.4], [0, 0], [1.5, 2.4], [0, 0.5]],
            v: [[3.55, 8.85], [4.35, 8.05], [0.65, -4.45], [-3.05, -8.65], [-4.15, -8.55], [-4.05, -7.45], [-0.65, -3.55], [2.75, 8.05]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.513725490196, 0.392156862745, 0.749019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [32.7, 12.2],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 14',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 15,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: 'head',
    parent: 9,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [24, -8.25, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [9.2, 9.75, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-1, 0.2], [0, 0], [0, 0], [0.7, -0.2], [-0.4, -0.8]],
            o: [[0, 0], [0, 0], [-0.2, -0.6], [-0.8, 0.2], [0.6, 0.8]],
            v: [[1.65, 1.5], [1.65, 1.5], [1.05, -0.7], [-0.45, -1.5], [-1.25, 0.4]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [5.9, 12.85],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-0.2, 1.1], [-1.1, -0.2], [0.2, -1.1], [1.1, 0.2]],
            o: [[0.2, -1.1], [1.1, 0.2], [-0.2, 1.1], [-1.1, -0.2]],
            v: [[-2, -0.4], [0.4, -2], [2, 0.4], [-0.4, 2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [2.85, 11.05],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[1.5, 0.6], [-0.7, 1.5], [-1.5, -0.7], [0.7, -1.5]],
            o: [[-1.4, -0.7], [0.7, -1.4], [1.4, 0.7], [-0.7, 1.4]],
            v: [[-1.25, 2.7], [-2.65, -1.2], [1.25, -2.6], [2.65, 1.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [10, 3.55],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 3,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[1.4, 0.7], [-0.7, 1.5], [-1.5, -0.7], [0.7, -1.5]],
            o: [[-1.4, -0.7], [0.7, -1.4], [1.4, 0.7], [-0.8, 1.5]],
            v: [[-1.25, 2.65], [-2.65, -1.25], [1.25, -2.65], [2.65, 1.25]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [5.6, 4.1],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 4',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 4,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[1.4, 0.7], [-0.7, 1.5], [-1.5, -0.7], [0.7, -1.5]],
            o: [[-1.4, -0.7], [0.7, -1.4], [1.4, 0.7], [-0.8, 1.5]],
            v: [[-1.25, 2.65], [-2.65, -1.25], [1.25, -2.65], [2.65, 1.25]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [3.6, 7.2],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 5',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 5,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 1.2], [-1.1, 0], [0, -1.1], [1.1, 0]],
            o: [[0, -1.1], [1.1, 0], [0, 1.1], [-1.2, 0.1]],
            v: [[-2.05, 0], [-0.05, -2.1], [2.05, -0.1], [0.05, 2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [4.6, 13.45],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 6',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 6,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0.1, 1.5], [-1.7, 0.1], [-0.1, -1.5], [1.7, -0.1]],
            o: [[0, -1.4], [1.7, 0], [0, 1.5], [-1.7, 0]],
            v: [[-3.05, 0.05], [-0.05, -2.65], [3.05, -0.05], [0.05, 2.65]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [5.8, 9.7],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 7',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 7,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-0.4, 1.9], [-1.9, -0.4], [0.4, -1.9], [1.9, 0.4]],
            o: [[0.4, -1.9], [1.9, 0.4], [-0.4, 1.9], [-1.9, -0.5]],
            v: [[-3.45, -0.75], [0.75, -3.45], [3.45, 0.75], [-0.75, 3.45]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [8.9, 6.6],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 8',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 8,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[1.4, 0.7], [-0.7, 1.5], [-1.5, -0.7], [0.7, -1.5]],
            o: [[-1.4, -0.7], [0.7, -1.4], [1.4, 0.7], [-0.7, 1.5]],
            v: [[-1.25, 2.65], [-2.65, -1.25], [1.25, -2.65], [2.65, 1.25]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [13.9, 5.4],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 9',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 9,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-0.8, 0.1], [0.1, 0.8]],
            o: [[0.1, 0.8], [0.8, -0.1], [0, 0]],
            v: [[-1.5, -0.55], [0.1, 0.75], [1.4, -0.85]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 0.980392156863, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [12.35, 15.3],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 10',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 10,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0.4, 0]],
            o: [[0, 0], [0.2, 0.4], [0, 0]],
            v: [[-0.15, -0.75], [0.15, -0.15], [-0.35, 0.75]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0.603,
          ix: 5
        },
        lc: 2,
        lj: 2,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [12.6, 12.5],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 11',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 11,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, -0.1], [0.2, 0], [0, 0.2], [-0.2, 0]],
            o: [[0, 0.2], [-0.2, 0], [0, -0.2], [0.2, 0.1]],
            v: [[0.3, 0], [0, 0.3], [-0.3, 0], [0, -0.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0.1,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 10,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [14.45, 11.85],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 12',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 12,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, -0.1], [0.2, 0], [0, 0.2], [-0.2, 0]],
            o: [[0, 0.2], [-0.2, 0], [0, -0.2], [0.2, 0.1]],
            v: [[0.3, 0], [0, 0.3], [-0.3, 0], [0, -0.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [14.45, 11.85],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 13',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 13,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, -0.2], [0.2, 0], [0, 0.2], [-0.2, 0]],
            o: [[0, 0.2], [-0.2, 0], [0, -0.2], [0.2, 0]],
            v: [[0.3, 0], [0, 0.3], [-0.3, 0], [0, -0.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0.1,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 10,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [9.25, 12.35],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 14',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 14,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, -0.2], [0.2, 0], [0, 0.2], [-0.2, 0]],
            o: [[0, 0.2], [-0.2, 0], [0, -0.2], [0.2, 0]],
            v: [[0.3, 0], [0, 0.3], [-0.3, 0], [0, -0.3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [9.25, 12.35],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 15',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 15,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-0.2, -3], [-3, 0.3], [0.2, 3], [3, -0.3]],
            o: [[0.2, 3], [4.4, -0.3], [-0.2, -3], [-3.2, 0.2]],
            v: [[-5.5, -0.3], [0.4, 6.2], [5.5, -1.2], [-0.3, -6.2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [11.35, 12.65],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 16',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 16,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[1.5, 0.7], [-0.7, 1.5], [-1.5, -0.7], [0.7, -1.5]],
            o: [[-1.4, -0.7], [0.7, -1.4], [1.5, 0.7], [-0.7, 1.5]],
            v: [[-1.25, 2.65], [-2.65, -1.25], [1.25, -2.65], [2.65, 1.25]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.231372563979, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [14.8, 8.3],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 17',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 17,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-1, -0.9], [0.7, -0.7], [0.3, 1.4]],
            o: [[-0.3, 0.6], [-0.8, -0.6], [-0.2, -1.1]],
            v: [[1.7, 0.45], [0.2, 2.45], [-1.5, -1.35]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [8.35, 16.8],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 19',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 18,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 7,
    ty: 4,
    nm: 'hood',
    parent: 9,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [18.3, 1.6, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [8.5, 7.2, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-2.1, 0.8], [0, 0], [-0.7, -2.1], [0, 0], [2.9, -7.5], [4, 0.4]],
            o: [[2.5, -0.9], [0, 0], [0, 0], [0, 0], [0, 0], [0.1, -0.1]],
            v: [[-4.1, -4.6], [-0.7, -4.3], [3.2, 0.8], [4.1, -2.2], [4.1, 5.5], [-7, -0.5]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.952941236309, 0.952941236309, 0.878431432387, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [9.75, 8.65],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-0.9, 0.4], [-0.3, -2.5], [0.9, 0.1]],
            o: [[0.8, -0.6], [0, 0], [0, 0], [-2.1, -0.1]],
            v: [[-3.75, 1.05], [-1.15, -0.55], [3.75, 1.25], [0.15, 0.25]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [4, 8.6],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0.1, 3.1], [0, 0]],
            o: [[0, 0], [-0.1, -1.8], [0, 0]],
            v: [[-0.9, 3], [0.8, -1.2], [-0.9, -3]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [14.85, 11.05],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 3,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [-1.6, 1.3], [0, 0]],
            o: [[0, 0], [0.1, 1.2], [0.4, -0.3], [0, 0]],
            v: [[-1.45, -5.15], [-2.95, 1.15], [1.55, 3.85], [2.95, -1.95]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [11.7, 5.4],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 4',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 4,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: 'jacket',
    parent: 9,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [11.6, 25.95, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [12.7, 25.15, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-0.2, -1], [2.2, 13.9]],
            o: [[0.4, 1.2], [0, 0], [0, 0]],
            v: [[8.8, 2.05], [9.5, 5.45], [-9.5, -6.95]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.101960784314, 0.03137254902, 0.149019607843, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [15.15, 37.5],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-6.7, 7.5], [-3.4, 0.5], [0.1, -8.4], [1.4, 2.6]],
            o: [[3.3, -3.7], [0.9, 8], [-8.1, 0.6], [-1.4, -17.2]],
            v: [[-4.65, -19], [5.55, -24.9], [12.35, 24.3], [-11.05, 19.9]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [12.7, 25.15],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 9,
    ty: 4,
    nm: 'torso',
    parent: 14,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.324,
            y: 1
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 0,
          s: [38.89, 45.55, 0],
          to: [1.577, 0, 0],
          ti: [-1.577, 0, 0]
        }, {
          t: 9,
          s: [48.35, 45.55, 0]
        }],
        ix: 2
      },
      a: {
        a: 0,
        k: [22.35, 26.75, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-0.2, -6], [0, -3.9], [1.2, -0.4], [-0.7, 7.3], [2.5, 2.9]],
            o: [[0.6, 13.6], [-0.8, 0.4], [-0.4, -5.4], [0.5, -5.2], [5, 2.8]],
            v: [[0.25, -8.4], [5.15, 21.2], [-0.05, 22.8], [-1.75, -10.5], [-5.15, -22.8]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [30.8, 25.45],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[2.3, 4.3], [-6.8, 7.5], [-4.7, -1.1], [1.6, -6.7], [0, -4]],
            o: [[-1.3, -17.2], [5, -5.6], [6.7, 1.5], [-3.2, 13.3], [-7.6, 3.8]],
            v: [[-14.1, 19.9], [-10.3, -17.5], [5, -23.1], [12.3, -7.3], [17.1, 20.1]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.952941176471, 0.952941176471, 0.878431372549, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [17.35, 24.45],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 3,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 10,
    ty: 4,
    nm: 'arm',
    parent: 9,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          t: 4,
          s: [22]
        }, {
          t: 15,
          s: [0]
        }],
        ix: 10
      },
      p: {
        a: 0,
        k: [21.373, 6.268, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [12.973, 4.768, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-4.5, -1.2], [-4.7, -3.7], [-3.9, 0.9], [-0.4, -1.4], [4, -1], [15.2, 18.8]],
            o: [[5.3, 1.4], [3.6, 2.8], [0.5, 0.6], [-1.2, 1.2], [-7.7, 1.9], [-9.6, -12.2]],
            v: [[-8.15, -15.75], [6.05, 4.45], [23.25, 0.95], [25.75, 6.15], [9.05, 15.05], [-16.15, -3.15]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [26, 17.2],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[3, 2.5], [-0.4, 0.8], [1, 1.1], [-0.399, -1.1], [-1.901, -1.2]],
            o: [[0, 0], [0.4, -0.8], [-1, -1.1], [0.3, 1.1], [1.899, 1.3]],
            v: [[-2.022, 1.788], [-2.222, -0.912], [-2.222, -4.212], [-0.522, -4.212], [1.079, -1.512]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 1,
          k: [{
            i: {
              x: 0.667,
              y: 1
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 9,
            s: [52.25, 16.85],
            to: [0, -0.167],
            ti: [0, 0.167]
          }, {
            t: 16,
            s: [52.25, 15.85]
          }],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 1,
          k: [{
            i: {
              x: [0.667],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 9,
            s: [84]
          }, {
            t: 16,
            s: [0]
          }],
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0.4, 3.9], [-2.101, -1.2], [1.5, -1.8], [0, 0]],
            o: [[0, 0], [0, 0], [1, 0.5], [-1.5, 1.6], [0, 0]],
            v: [[-6.45, 1.9], [-0.65, -3.5], [3.651, -4.4], [4.95, 1.2], [-2.65, 5.6]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [53.3, 17.75],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 3,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 11,
    ty: 4,
    nm: 'legs',
    parent: 14,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [31.3, 98.05, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [31.8, 41.65, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 1,
          k: [{
            i: {
              x: 0.324,
              y: 1
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            t: 0,
            s: [{
              i: [[0, 0], [-11.4, 8.8], [-2.9, 9.4], [-0.2, 0.9], [-9.9, 1.8], [-0.5, -3.1], [1.3, -9.7], [0, 0], [0, 0], [0, 6.7], [0, 0], [5.5, -6.7], [0, 0]],
              o: [[0, 0], [5.8, -4.5], [0.3, -1], [3.9, 0.4], [1.2, 2.9], [1.9, 11.4], [-1.2, 9.1], [0, 0], [0, 0], [0, -5.4], [-1.3, 5.1], [-11.8, 14.5], [0, 0]],
              v: [[-41.28, 13.292], [-17.98, -3.308], [-10.169, -34.4], [-6.869, -40.6], [16.931, -41.4], [20.331, -34.7], [34.034, 6.57], [31.358, 41.67], [16.658, 41.27], [18.053, 2.141], [6.372, -20.659], [-3.08, 4.492], [-33.58, 26.992]],
              c: true
            }]
          }, {
            t: 9,
            s: [{
              i: [[0, 0], [-4.292, 16.989], [-2.9, 9.4], [-0.2, 0.9], [-9.9, 1.8], [-0.5, -3.1], [1.3, -9.7], [0, 0], [0, 0], [0, 6.7], [0, 0], [1.084, -8.108], [0, 0]],
              o: [[0, 0], [1.942, -7.686], [0.3, -1], [3.9, 0.4], [1.2, 2.9], [1.9, 11.4], [-1.2, 9.1], [0, 0], [0, 0], [0, -5.4], [0.005, 5.692], [-1.084, 8.108], [0, 0]],
              v: [[-0.739, 41.13], [0.669, 6.151], [-1.25, -34.4], [2.05, -40.6], [25.85, -41.4], [29.25, -34.7], [34.845, 4.949], [32.98, 41.13], [18.28, 40.73], [20.215, 2.411], [14.75, -21.2], [14.488, 6.114], [13.447, 41.586]],
              c: true
            }]
          }],
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'mm',
        mm: 4,
        nm: 'Merge Paths 1',
        mn: 'ADBE Vector Filter - Merge',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.23137254902, 0.066666666667, 0.356862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [31.8, 41.65],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 12,
    ty: 4,
    nm: 'foot',
    parent: 14,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [59.319, 141.529, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [7.8, 5, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0.1], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-0.9, 1], [0, 0], [-2, -1.8], [0, 0], [0, 0], [-0.1, -0.101], [-0.1, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.1, -0.1], [0.2, 0], [1.2, 0], [1.6, 0.099], [1.1, 0.1], [0.3, 0], [0.3, 0.199], [0, 0], [0, 0], [0, 0], [0.1, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0.3, -1.699], [0, 0], [0.3, -0.401], [0, 0], [0, 0], [0, 0], [0.1, 0.099], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-0.1, 0], [-0.1, 0], [-0.7, 0.101], [-1.4, 0], [-1.4, -0.101], [-0.3, 0], [-0.7, -0.099], [-0.1, 0], [0, 0], [0, 0], [-0.1, -0.101], [0.1, 0.401]],
            v: [[-7.45, 2.101], [-7.45, 2.101], [-7.45, 1.901], [-7.45, 1.701], [-7.45, 1.5], [-7.45, 1.3], [-4.85, -3], [0.25, -1.299], [-0.55, -3], [7.05, 1.701], [7.15, 1.8], [7.25, 1.901], [7.45, 2.101], [7.55, 2.201], [7.55, 2.3], [7.55, 2.401], [7.55, 2.5], [7.55, 2.601], [7.45, 2.601], [7.25, 2.701], [6.75, 2.8], [3.75, 3], [-0.95, 2.901], [-4.75, 2.601], [-5.65, 2.5], [-7.15, 2.101], [-7.25, 2], [-7.35, 2], [-7.45, 1.901], [-7.55, 1.8]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [7.8, 6.749],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [-0.4, -1.3], [1.5, 1.1], [0, 0]],
            o: [[0, 0], [0, 0], [0, 0], [0.4, 1.3], [-1.5, -1.1], [0, 0]],
            v: [[-3.65, -2.55], [0.95, -3.75], [0.95, -0.15], [3.25, 2.45], [-1.35, 2.25], [-3.35, -0.15]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [6.2, 4],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 13,
    ty: 4,
    nm: 'foot',
    parent: 14,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.367],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          t: 0,
          s: [0]
        }, {
          t: 9,
          s: [-91]
        }],
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.367,
            y: 1
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          t: 0,
          s: [-8.47, 121.701, 0],
          to: [8.108, 3.423, 0],
          ti: [-8.108, -3.423, 0]
        }, {
          t: 9,
          s: [40.178, 142.242, 0]
        }],
        ix: 2
      },
      a: {
        a: 0,
        k: [4.2, 7.75, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, -0.1], [0, 0], [0, 0.1], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-1, -0.9], [0, 0], [1.8, -2], [0, 0], [0, 0], [0, 0], [0, -0.1], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0.4], [0.1, 0.3], [-0.1, 1.1], [0, 0], [0, 0.8], [-0.4, 0.8]],
            o: [[0, -0.1], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [1.6, 0.4], [0, 0], [0.4, 0.3], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-0.1, -0.2], [0, -0.2], [-0.1, -0.8], [0, 0], [0, -0.8], [0.2, -2.8], [-0.2, -0.1]],
            v: [[-2.1, -7.3], [-2.1, -7.3], [-2, -7.4], [-1.9, -7.5], [-1.8, -7.5], [-1.7, -7.5], [-1.5, -7.5], [-1.3, -7.5], [-1.1, -7.5], [3.1, -4.8], [1.3, 0.3], [3, -0.5], [-1.8, 7], [-1.9, 7.1], [-2, 7.2], [-2.2, 7.4], [-2.3, 7.5], [-2.4, 7.5], [-2.5, 7.5], [-2.6, 7.5], [-2.7, 7.5], [-2.7, 7.4], [-2.9, 6.4], [-3, 5.6], [-3, 2.6], [-3, 1.4], [-2.9, -1], [-2, -7.1]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.666666666667, 0.560784313725, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [3.35, 7.75],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0], [0.8, -0.3], [-0.6, 2]],
            o: [[0, 0], [0, 0], [0, 0], [0, 0], [-0.8, 0.3], [0.8, -1.9]],
            v: [[0.65, -3.1], [2.05, -3.1], [2.25, 1.1], [0.55, 1.2], [-1.05, 2.8], [-1.65, -0.2]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.713725490196, 0.450980392157, 0.36862745098, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [5.9, 5.95],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 14,
    ty: 4,
    nm: 'grey circle',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [175, 160, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [80.649, 80.65, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [185, 185, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-44.404, 0], [0, -44.404], [44.403, 0], [0, 44.404]],
            o: [[44.403, 0], [0, 44.404], [-44.404, 0], [0, -44.404]],
            v: [[0.001, -80.4], [80.399, 0], [0.001, 80.4], [-80.4, 0]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'mm',
        mm: 4,
        nm: 'Merge Paths 1',
        mn: 'ADBE Vector Filter - Merge',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.929411764706, 0.901960784314, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [80.649, 80.65],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 240,
    st: 0,
    bm: 0
  }],
  markers: []
};
exports["default"] = _default;